// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const className = require('classnames');

// @ utils
const { formatAmount } = require('utilities/currencyHelper');

// @ utils
const { formatText, getLanguage } = require('core/i18n').i18n;

// @ constants
const { EURO_SYMBOL } = require('constants/index');

const InsuranceRequestPlansHeaderCell = (props) => {

    const {
        column,
        immInsuranceWizardStep,
        insuranceUsabilityImprovementsFlag,
        isColumnDisabled,
        onHandleHoverColumn,
        plan,
        title,
    } = props;

    const titleKey = title ? title.toLowerCase() : '';
    const planKey = plan.toLowerCase();
    const language = getLanguage();
    const totalImport = immInsuranceWizardStep.getIn(['quotationData', planKey, 'totalImport']);
    const customClass = className('coverage-and-plans__table-cell coverage-and-plans__table-cell-header', {
        'coverage-and-plans__table-cell-header--disabled': isColumnDisabled(column),
        'coverage-and-plans__table-cell-header-version-1': !insuranceUsabilityImprovementsFlag,
        'coverage-and-plans__table-cell-header-version-2': insuranceUsabilityImprovementsFlag,
        'coverage-and-plans__table-cell-header--color-basic': planKey === 'basic',
        'coverage-and-plans__table-cell-header--color-medium': planKey === 'medium',
        'coverage-and-plans__table-cell-header--color-high': planKey === 'high',
    });
    const paymentType = immInsuranceWizardStep.getIn(['quotationData', planKey, 'paymentType']);
    const paymentTypeToLowerCase = paymentType ? paymentType.toLowerCase() : paymentType;
    const planNameClass = className('coverage-and-plans__table-cell-header__plan-name coverage-and-plans__table-cell-header--plans', {
        'coverage-and-plans__table-cell-header-version-1__plan-name': !insuranceUsabilityImprovementsFlag,
        'coverage-and-plans__table-cell-header-version-2__plan-name': insuranceUsabilityImprovementsFlag,
    });
    const moneyClass = className('coverage-and-plans__table-cell-header__money coverage-and-plans__table-cell-header--plans', {
        'coverage-and-plans__table-cell-header-version-1__money': !insuranceUsabilityImprovementsFlag,
        'coverage-and-plans__table-cell-header-version-2__money': insuranceUsabilityImprovementsFlag,
    });
    const paymentTypeClass = className('coverage-and-plans__table-cell-header__payment-type coverage-and-plans__table-cell-header--plans', {
        'coverage-and-plans__table-cell-header-version-1__payment-type': !insuranceUsabilityImprovementsFlag,
        'coverage-and-plans__table-cell-header-version-2__payment-type': insuranceUsabilityImprovementsFlag,
    });
    return (
        <th
            key={column}
            className={customClass}
            onMouseEnter={onHandleHoverColumn}
        >
            <div className={planNameClass}>
                {formatText(`insuranceRequestHome-step3${planKey}PlanTitle`)}
            </div>
            {insuranceUsabilityImprovementsFlag && (
                <div className="coverage-and-plans__table-cell-header__plan-name-detail coverage-and-plans__table-cell-header--plans">
                    {formatText(`insuranceRequestHome-insuranceRequestHome_step3${titleKey}PlanTitleDetail`)}
                </div>
            )}
            <div className={moneyClass}>
                {`${formatAmount(totalImport, language, 2)} ${EURO_SYMBOL}`}
            </div>
            <div className={paymentTypeClass}>
                {formatText(`insuranceRequestHome-step3${paymentTypeToLowerCase}Label`)}
            </div>
        </th>
    );
};

InsuranceRequestPlansHeaderCell.propTypes = {
    column: PropTypes.number.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    insuranceUsabilityImprovementsFlag: PropTypes.bool,
    isColumnDisabled: PropTypes.func.isRequired,
    onHandleHoverColumn: PropTypes.func.isRequired,
    plan: PropTypes.string.isRequired,
    title: PropTypes.string,
};

module.exports = InsuranceRequestPlansHeaderCell;
